// Persistência local (auto-save) do wizard de cadastro de negócio.
//
// Estratégia: cada usuário (email) tem uma chave própria
// `cadastro_draft_{email}` no localStorage. O objeto salvo é
// `{ step, form }`. Este helper é chamado no mount do wizard para
// hidratar o formulário caso o usuário tenha abandonado no meio.

/**
 * Lê o rascunho local salvo pelo auto-save.
 * Retorna `null` se:
 *   - não houver usuário logado (`localStorage.user` vazio ou inválido);
 *   - a rota veio com `?continue=<id>` (aí carregamos do servidor);
 *   - nenhum rascunho encontrado;
 *   - rascunho encontrado mas sem `nome` nem `cnpj_cpf` (rascunho vazio).
 */
export const readLocalDraft = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || 'null');
    const qp = new URLSearchParams(window.location.search);
    if (!u?.email || qp.get('continue')) return null;
    const saved = JSON.parse(localStorage.getItem(`cadastro_draft_${u.email}`) || 'null');
    if (saved?.form && (saved.form.nome || saved.form.cnpj_cpf)) return saved;
  } catch { /* ignora */ }
  return null;
};
